import { Link, useNavigate } from "react-router-dom";
import { Rocket, Layers, ChevronRight } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect } from "react";

const pipelines = [
  {
    key: "pipeline1",
    icon: Rocket,
    accentClass: "bg-orange-50",
    title: "Pipeline 1: Auto-Furnish",
    desc: "The fastest way to visualize your room. Upload a single image of your empty space, and our AI will automatically suggest and place furniture based on the room's architecture.",
    label: "Start Auto Pipeline",
    to: "/interior-design-ai/pipeline1",
  },
  {
    key: "pipeline2",
    icon: Layers,
    accentClass: "bg-orange-50",
    title: "Pipeline 2: Custom Assets",
    desc: "Full creative control. Upload your room along with up to 7 specific furniture items you already own or love, and see how they fit perfectly in your new space.",
    label: "Start Custom Pipeline",
    to: "/interior-design-ai/pipeline2",
  },
];

export default function Dashboard() {
  const nav = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading && !isAuthenticated) nav("/login");
  }, [isAuthenticated, loading, nav]);

  return (
    <div className="min-h-screen" style={{ background: "var(--surface)" }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        {/* Header */}
        <div className="mb-8 animate-fade-up">
          <h2
            className="text-2xl sm:text-3xl font-bold"
            style={{ fontFamily: "'Outfit', sans-serif", color: "var(--text-primary)" }}
          >
            Design Dashboard
          </h2>
          <p className="text-sm mt-1" style={{ color: "var(--text-secondary)" }}>
            Select your preferred transformation pipeline
          </p>
        </div>

        {/* Pipeline cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {pipelines.map(({ key, icon: Icon, accentClass, title, desc, label, to }, i) => (
            <div
              key={key}
              className="card-premium p-6 flex flex-col justify-between gap-6 animate-fade-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="space-y-4">
                <div className={`w-14 h-14 rounded-2xl ${accentClass} flex items-center justify-center`}>
                  <Icon className="w-7 h-7" style={{ color: "var(--orange)" }} />
                </div>
                <div>
                  <h3
                    className="text-lg font-bold mb-2"
                    style={{ fontFamily: "'Outfit', sans-serif", color: "var(--text-primary)" }}
                  >
                    {title}
                  </h3>
                  <p className="text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                    {desc}
                  </p>
                </div>
              </div>
              <Link to={to}>
                <button
                  className="btn-primary-glow w-full py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 text-white transition-all"
                  style={{ background: "linear-gradient(135deg, var(--orange), var(--orange-light))" }}
                >
                  {label} <ChevronRight className="w-4 h-4" />
                </button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
